var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AutoLogout'),_c('TheHeader'),_c('keep-alive',[_c('router-view')],1),_c('TheSidebar'),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }